<mat-card>
  <mat-card-header>
    <mat-card-title>Liquidación de Expensas</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <form [formGroup]="form0Group">

        <mat-expansion-panel [expanded]="true" hideToggle="true">

          <div fxLayout="row stretch" class="zb-readonly" fxLayoutAlign="center center" style="margin-top: 20px;">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}*</mat-label>
                <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                <mat-select formControlName="Comunidad" (selectionChange)="onInitialConfigChange()">
                  <mat-option *ngFor="let s of comunidadList" [value]="s">{{s.Nombre}}</mat-option>
                </mat-select>
                <mat-error *ngIf="!form0Group.controls['Comunidad'].valid && form0Group.controls['Comunidad'].touched">
                  {{ getError0Comunidad() }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex=30 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Mes de Período a Liquidar*</mat-label>
                <mat-select formControlName="PeriodoMes" [compareWith]="compareMeses" (selectionChange)="onInitialConfigChange()">
                  <mat-option *ngFor="let s of mesesList" [value]="s">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex=20 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label>Año de Período a Liquidar*</mat-label>
                <input matInput type="number" formControlName="PeriodoAnio" (keyup.enter)="onSearch()" maxlength="4" (change)="onInitialConfigChange()">
              </mat-form-field>
            </div>

          </div>

          <div fxLayout="row-reverse stretch" fxLayout.xs="column">
            <button mat-raised-button (click)="onComunidadSelection(true)" [disabled]="isSaving || isSimulating" class="zb-button">Revisar Configuración</button>
            <button mat-raised-button (click)="onComunidadSelection(false)" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">Liquidar</button>
          </div>

        </mat-expansion-panel>

        <br/>

      </form>

      <ng-container *ngIf="(comunidadSeleccionada != null && comunidadSeleccionada.Id > 0)">

        <!-- PASO 1: CONFIGURACION DE EXPENSAS DEL CONSORCIO -->
        <mat-expansion-panel [expanded]="step===1" (opened)="setStep(1)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">search</mat-icon> PASO 1: Revisión de Configuración de {{'Consorcio' | translate}} y {{'Comunidad' | translate}}
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <!-- DATOS DE COMUNIDAD Y CONSORCIO -->
          <div fxLayout="row" fxLayout.xs="column">

            <mat-expansion-panel [expanded]="true" style="width: 100%;">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px; margin-right: 5px;">settings</mat-icon> Configuración de {{'Consorcio' | translate}} y {{'Comunidad' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 10px;">
                  <mat-label style="text-align: center; font-weight: bold;">Estos son los parámetros se utilizarán para calcular las expensas</mat-label>
                </div>

                <ng-container *ngIf="isConsorcioSearching">
                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <mat-label><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                  </div>
                </ng-container>

                <ng-container *ngIf="!isConsorcioSearching">

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Interés Vencimiento</b>: {{consorcioSeleccionado.InteresVencimiento | number: '1.2-2'}}%</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Interés Mensual</b>: {{consorcioSeleccionado.InteresMensual | number: '1.2-2'}}%</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Método de Redondeo Expensa</b>: {{consorcioSeleccionado.MetodoRedondeoExpensaNombre}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Conceptos Recargo</b>: {{consorcioSeleccionado.ConceptosRecargoNombre}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="mostrarSeleccionConceptosRecargo">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Gastos del Concepto de Recargo</b>: {{tipoGastosConceptosRecargoString}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>
                  <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-bottom: 15px;">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Validar Porcentaje de {{'UnidadFuncional' | translate}}</b>: {{consorcioSeleccionado.ValidarUfTotalPorcentaje ? 'Sí' : 'No'}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label><b>Nota de Expensas</b>:
                          <br/>
                          {{consorcioSeleccionado.NotaExpensas}}</mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                  <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                    <mat-expansion-panel [expanded]="true" hideToggle="true">
                      <div fxLayout="row stretch" fxLayout.xs="column">
                        <mat-label>
                          <b>Nota de Pie de Expensas</b>:
                          <br/>
                          {{consorcioSeleccionado.NotaExpensasPie}}
                        </mat-label>
                      </div>
                    </mat-expansion-panel>
                  </div>

                </ng-container>

              </div>

            </mat-expansion-panel>

          </div>

          <br/>

          <!-- PORCENTAJES DE UFS -->
          <div fxLayout="row" fxLayout.xs="column">

            <mat-expansion-panel [expanded]="true" style="width: 100%;">

              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon style="margin-top: -3px; margin-right: 5px;">meeting_room</mat-icon> Porcentajes de {{'UnidadFuncional' | translate}}
                </mat-panel-title>
                <mat-panel-description>
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
                <mat-label *ngIf="isUfSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
                <mat-label *ngIf="!isUfSearching && (ufPorcentajesList == null || ufPorcentajesList.length == 0)">No hay unidades funcionales en la {{('Comunidad' | translate).toLowerCase()}} seleccionada</mat-label>
              </div>

              <div id="divUfPorcentaje" fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column" *ngIf="!isUfSearching && (ufPorcentajesList != null && ufPorcentajesList.length > 0)">

                <div fxFlex=100 fxFlex.xs=100 class="flex-item">

                  <ejs-grid #ufPorcentajeGrid [dataSource]='ufPorcentajesList' [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions'
                    [allowResizing]='true' [allowFiltering]='true' [allowPaging]="true" [pageSettings]='pageSettings' (actionFailure)="onGridActionFailure($event)">
                    <e-columns>
                      <e-column field="UnidadFuncionalNumero" headerText='Nro. UF' width="90"></e-column>
                      <e-column field="UnidadFuncionalCodigo" headerText='Cód. UF' width="90"></e-column>
                      <e-column field="UnidadFuncionalTipo" headerText='Tipo Unidad' width="120"></e-column>
                      <ng-container *ngIf="ufPorcentajesList != null && ufPorcentajesList.length > 0">
                        <ng-container *ngFor="let gasto of ufPorcentajesList[0]?.TipoGastoPorcentajes">
                          <e-column field="{{gasto?.TipoGastoId}}" headerText='{{gasto?.TipoGasto}}' width="90" textAlign='Right'></e-column>
                        </ng-container>
                      </ng-container>
                    </e-columns>
                    <ng-template #rowTemplate let-data>
                      <tr class="e-row">
                        <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalNumero}}</td>
                        <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalCodigo}}</td>
                        <td class="e-rowcell" style="text-align: center;">{{data.UnidadFuncionalTipo}}</td>
                        <ng-container *ngFor="let gasto of data?.TipoGastoPorcentajes">
                          <td class="e-rowcell" align='right' textAlign='Right'>
                            {{gasto.Porcentaje | number: '1.2-2'}}%
                          </td>
                        </ng-container>
                      </tr>
                    </ng-template>
                    <e-aggregates>
                      <e-aggregate>
                        <e-columns>
                          <e-column field="UnidadFuncionalNumero" type="count">
                            <ng-template #footerTemplate let-data>Cantidad: {{data.count}}</ng-template>
                          </e-column>
                          <ng-container *ngIf="ufPorcentajesList != null && ufPorcentajesList.length > 0">
                            <ng-container *ngFor="let gasto of ufPorcentajesList[0]?.TipoGastoPorcentajes">
                              <e-column field="{{gasto?.TipoGastoId}}" type="Custom" textAlign='Right'>
                                <ng-template #footerTemplate let-data>{{sumUfPorcentaje(gasto.TipoGastoId) | number:'1.2-2'}}%</ng-template>
                              </e-column>
                            </ng-container>
                          </ng-container>
                        </e-columns>
                      </e-aggregate>
                    </e-aggregates>
                  </ejs-grid>

                </div>

              </div>

            </mat-expansion-panel>

          </div>

          <ng-container *ngIf="canConfigExpensas">

            <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

            <div fxLayout="row" fxLayout.xs="column">
              <div fxFlex=100 fxFlex.xs=100 class="flex-item" style="text-align: center; margin-bottom: 10px;">
                <mat-label style="text-align: center; font-weight: bold;">¿Queres cambiar alguna configuración?</mat-label>
                <br/><br/>
                <button mat-raised-button (click)="goExpensaConfig()" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">Cambiar Configuración de Expensas</button>
              </div>
            </div>

          </ng-container>

          <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
            <button mat-raised-button (click)="onStep1Guardar()" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">{{isSaving && step===1 ? 'Guardando...' : 'Siguiente'}}</button>
          </div>

        </mat-expansion-panel>

        <br />

        <!-- PASO 2: SELECCION DE GASTOS DEL PERIODO -->
        <mat-expansion-panel [expanded]="step===2" (opened)="setStep(2)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">attach_money</mat-icon> PASO 2: Gastos a Liquidar
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="form2Group">

            <div fxLayout="row stretch" fxLayout.xs="column">

              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoGastoComunidadSearching">Tipos de Gasto</mat-label>
                  <mat-label *ngIf="isTipoGastoComunidadSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoGastoId">
                    <mat-option>Todos</mat-option>
                    <mat-option *ngFor="let s of comunidadTipoGastoList" [value]="s.Id">{{s.TipoGasto}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isServicioSearching">Servicios</mat-label>
                  <mat-label *ngIf="isServicioSearching">Cargando...</mat-label>
                  <mat-select formControlName="Servicios" multiple [compareWith]="compareServicios">
                    <mat-option *ngFor="let s of serviciosList" [value]="s.Id">{{s.Nombre}} <!-- - {{s.CategoriaGastoNombre}}--></mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isMonedaSearching">Moneda</mat-label>
                  <mat-label *ngIf="isMonedaSearching">Cargando...</mat-label>
                  <mat-select formControlName="MonedaId">
                    <mat-option>Todas</mat-option>
                    <mat-option *ngFor="let s of monedaList" [value]="s.Id">{{s.Codigo}} - {{s.Nombre}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div fxFlex=33 fxFlex.xs=100 class="flex-item" style="margin-top: 15px;">
                <mat-checkbox [(ngModel)]="verOtrosGastosPendientes" [ngModelOptions]="{standalone: true}" color="primary">
                </mat-checkbox>
                <mat-label style="margin-left: 5px;">Ver Gastos Pendientes de Otros Períodos</mat-label>
              </div>
              <ng-container *ngIf="verOtrosGastosPendientes">

                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%" >
                    <mat-label>Fecha de Gasto Desde</mat-label>
                    <input matInput [matDatepicker]="fechaGastoDesdePicker" formControlName="FechaGastoDesde" (click)="fechaGastoDesdePicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoDesdePicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoDesde')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaGastoDesdePicker></mat-datepicker>
                  </mat-form-field>
                </div>
                <div fxFlex=33 fxFlex.xs=100 class="flex-item">
                  <mat-form-field appearance="outline" style="width: 100%">
                    <mat-label>Fecha de Gasto Hasta</mat-label>
                    <input matInput [matDatepicker]="fechaGastoHastaPicker" formControlName="FechaGastoHasta"  (click)="fechaGastoHastaPicker.open()">
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaGastoHastaPicker">
                    </mat-datepicker-toggle>
                    <mat-datepicker-toggle style="display:inline-block;" matSuffix (click)="clearDate('FechaGastoHasta')">
                      <mat-icon matDatepickerToggleIcon>clear</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #fechaGastoHastaPicker></mat-datepicker>
                  </mat-form-field>
                </div>

              </ng-container>

            </div>

            <div fxLayout="row-reverse stretch" fxLayout.xs="column" style="margin: 10px 0px;">
              <button mat-raised-button (click)="onGastoSearch(true)" [disabled]="isSaving || isSimulating" color="primary" class="zb-button" style="margin-right: 5px;">Buscar</button>
              <button mat-raised-button (click)="onGastoAdd()" *ngIf="canGastoAdd" [disabled]="isSaving || isSimulating" class="zb-button">Agregar Gasto</button>
            </div>

          </form>

          <hr style="margin-top: 20px; margin-bottom: 20px; width: 100%;">

          <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

            <mat-label *ngIf="isGastoSearching"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>

            <mat-tab-group>

              <mat-tab label="{{'Comunidad' | translate}}">

                <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
                  <ejs-grid #gastosComunidadGrid [dataSource]='gastosComunidadPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                    [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onGastoComunidadRowSelected($event)'
                    (rowDeselected)='onGastoComunidadRowDeselected($event)' (dataBound)='onGastoComunidadDataBound($event)'>
                    <e-columns>
                      <e-column type='checkbox' width='40'></e-column>
                      <e-column field='FechaGasto' headerText='Fecha' width='90'>
                        <ng-template #template let-data>
                          {{data.FechaGasto | date:'dd/MM/yyyy'}}
                        </ng-template>
                      </e-column>
                      <e-column field='TipoGasto' headerText='Tipo Gasto' width='100'></e-column>
                      <e-column field='ServicioGasto' headerText='Servicio' width='100'></e-column>
                      <e-column field='Detalle' headerText='Detalle' width='150'></e-column>
                      <e-column field='Moneda' headerText='Moneda' width='70'></e-column>
                      <e-column field='Importe' headerText='Importe' width='90' textAlign='Right'>
                        <ng-template #template let-data>
                          {{data.Importe | number: '1.2-2'}}
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>

                <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
                  <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item" style="font-weight: bold; margin-top: 5px;">
                    Cantidad Total Seleccionada: {{cantidadGastosComunidadTotalSeleccionado}} - Monto Total Seleccionado: ${{gastosComunidadTotalSeleccionado | number:'1.2-2'}}
                  </div>
                </div>

              </mat-tab>

              <mat-tab label="{{'UnidadFuncional' | translate}}">

                <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
                  <ejs-grid #gastosUfsGrid [dataSource]='gastosUfPendientesList' [allowPaging]="true" [allowSorting]="true" [toolbar]='toolbarOptions'
                    [selectionSettings]='gastosSelectionOptions' [pageSettings]='pageSettings' [allowResizing]='true' (rowSelected)='onGastoUfRowSelected($event)'
                    (rowDeselected)='onGastoUfRowDeselected($event)' (dataBound)='onGastoUfDataBound($event)'>
                    <e-columns>
                      <e-column type='checkbox' width='40'></e-column>
                      <e-column field='FechaGasto' headerText='Fecha' width='90'>
                        <ng-template #template let-data>
                          {{data.FechaGasto | date:'dd/MM/yyyy'}}
                        </ng-template>
                      </e-column>
                      <e-column field='UnidadFuncionalCodigo' headerText='Cód.' width='90'></e-column>
                      <e-column field='TipoGasto' headerText='Tipo Gasto' width='100'></e-column>
                      <e-column field='ServicioGasto' headerText='Servicio' width='100'></e-column>
                      <e-column field='Detalle' headerText='Detalle' width='150'></e-column>
                      <e-column field='Moneda' headerText='Moneda' width='70'></e-column>
                      <e-column field='Importe' headerText='Importe' width='90' textAlign='Right'>
                        <ng-template #template let-data>
                          {{data.Importe | number: '1.2-2'}}
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>

                <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">
                  <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="end" class="flex-item" style="font-weight: bold; margin-top: 5px;">
                    Cantidad Total Seleccionada: {{cantidadGastosUfTotalSeleccionado}} - Monto Total Seleccionado: ${{gastosUfTotalSeleccionado | number:'1.2-2'}}
                  </div>
                </div>

              </mat-tab>

            </mat-tab-group>

          </div>

          <hr style="margin: 10px 0px; width: 100%;">

          <div fxLayout="row stretch" class="zb-readonly" fxLayout.xs="column">

            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Cantidad Total Seleccionada</b>: {{cantidadGastosTotalSeleccionado}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>
            <div fxFlex=50 fxFlex.xs=100 class="flex-item">
              <mat-expansion-panel [expanded]="true" hideToggle="true">
                <div fxLayout="row stretch" fxLayout.xs="column">
                  <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Monto Total a Liquidar</b>: ${{gastosTotalSeleccionado | number:'1.2-2'}}</mat-label>
                </div>
              </mat-expansion-panel>
            </div>

          </div>

          <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px; text-align: center;">
            <button mat-raised-button (click)="setStep(1)" [disabled]="isSaving || isSimulating" color="warn" class="zb-button">Atrás</button>
            <button mat-raised-button (click)="onStep2Guardar(2)" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">{{isSaving && step===2 ? 'Guardando...' : 'Siguiente'}}</button>
          </div>

        </mat-expansion-panel>

        <br />

        <!-- PASO 3: DATOS PARA LIQUIDAR LA EXPENSA -->
        <mat-expansion-panel [expanded]="step===3" (opened)="setStep(3)" hideToggle="true">

          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon style="margin-top: -3px; margin-right: 5px;">settings</mat-icon> PASO 3: Datos de la Liquidación de Expensa
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <form [formGroup]="form3Group">

            <div fxLayout="row stretch" fxLayout.xs="column" class="zb-readonly">

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-bottom: 15px;">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Período</b>: {{form0Group.get("PeriodoMes")?.value?.Nombre}}-{{form0Group.get("PeriodoAnio")?.value}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item" style="margin-bottom: 15px;">
                <mat-expansion-panel [expanded]="true" hideToggle="true">
                  <div fxLayout="row stretch" fxLayout.xs="column">
                    <mat-label class="text-style" style="text-align: center; width: 100%;"><b>Total a Liquidar en Gastos</b>: ${{gastosTotalSeleccionado | number:'1.2-2'}}</mat-label>
                  </div>
                </mat-expansion-panel>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fecha Vencimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaVencimientoPicker" formControlName="FechaVencimiento" (click)="fechaVencimientoPicker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimientoPicker></mat-datepicker>
                  <mat-error *ngIf="!form3Group.controls['FechaVencimiento'].valid && form3Group.controls['FechaVencimiento'].touched">
                    {{ getError3FechaVencimiento() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Segunda Fecha Vencimiento*</mat-label>
                  <input matInput [matDatepicker]="fechaVencimiento2Picker" formControlName="FechaVencimiento2" (click)="fechaVencimiento2Picker.open()">
                  <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimiento2Picker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #fechaVencimiento2Picker></mat-datepicker>
                  <mat-error *ngIf="!form3Group.controls['FechaVencimiento2'].valid && form3Group.controls['FechaVencimiento2'].touched">
                    {{ getError3FechaVencimiento2() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Fondo Operativo*</mat-label>
                  <input type="number" matInput formControlName="ImporteFondoOperativo" (wheel)="onWheel($event)">
                  <mat-error *ngIf="!form3Group.controls['ImporteFondoOperativo'].valid && form3Group.controls['ImporteFondoOperativo'].touched">
                    {{ getError3ImporteFondoOperativo() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=100 fxFlex.xs=100 class="flex-item">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label>Observaciones</mat-label>
                  <textarea matInput formControlName="Observaciones" maxlength="300"></textarea>
                  <mat-error *ngIf="!form3Group.controls['Observaciones'].valid && form3Group.controls['Observaciones'].touched">
                    {{ getError3Observaciones() }}
                  </mat-error>
                </mat-form-field>
              </div>

              <div fxFlex=50 fxFlex.xs=100 class="flex-item" *ngIf="tenantFeatureFlags?.HabilitarControlCaja">
                <mat-form-field appearance="outline" style="width: 100%">
                  <mat-label *ngIf="!isTipoMovimientoSearching">Tipo de Movimiento*</mat-label>
                  <mat-label *ngIf="isTipoMovimientoSearching">Cargando...</mat-label>
                  <mat-select formControlName="TipoMovimientoId">
                    <mat-option *ngFor="let s of tipoMovimientoList" [value]="s.Id">{{s.Nombre}}</mat-option>
                  </mat-select>
                  <mat-error *ngIf="!form3Group.controls['TipoMovimientoId'].valid && form3Group.controls['TipoMovimientoId'].touched">
                    {{ getErrorTipoMovimientoId() }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox formControlName="EnviarExpensa" color="primary">Realizar el envío por mail de la liquidación</mat-checkbox>
              </div>
              <div fxFlex=25 fxFlex.xs=100 class="flex-item" style="margin-top: 20px;">
                <mat-checkbox formControlName="PublicarExpensa" color="primary">Publicar la expensa una vez generada</mat-checkbox>
              </div>

            </div>

            <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="hayUfsSinCubrirTotal">
              <div fxFlex=100 fxFlex.xs=100 fxLayoutAlign="center" class="flex-item" style="border-radius: 10px; background-color: lightblue; padding-bottom: 15px;">
                <mat-label style="font-weight: bold; text-align: center; padding-top: 15px;">
                  <u>NOTA:</u> hay porcentajes de unidades funcionales que no suman el 100% de prorrateo para los gastos. Volvé al paso 1 si queres revisar estos valores.
                </mat-label>
              </div>
            </div>

          </form>

          <br/>

          <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
            <button mat-raised-button (click)="setStep(2)" [disabled]="isSaving || isSimulating" color="warn" class="zb-button">Atrás</button>
            <button mat-raised-button (click)="onStep3Guardar()" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">{{isSaving && step===3 ? 'Liquidando...' : 'Liquidar'}}</button>

            <button mat-raised-button (click)="onSimulacionClick()" [disabled]="isSaving || isSimulating" color="accent" class="zb-button">{{isSimulating && step===3 ? 'Simulando...' : 'Simular'}}</button>
            <button mat-raised-button (click)="onExpensaResultadoClick()" *ngIf="expensaResultado != null && this.expensaResultado.ExpensaCabeceraId > 0" [disabled]="isSaving || isSimulating" color="primary" class="zb-button">Ver Detalle</button>
          </div>

        </mat-expansion-panel>

      </ng-container>

    </ng-container>

    <br />

    <div fxLayout="row stretch" fxLayout.xs="column" style="text-align: center;">
      <button mat-raised-button (click)="onCancel()" [disabled]="isSaving" color="warn" class="zb-button">Cerrar</button>
    </div>

  </mat-card-content>
</mat-card>
